import dataService from 'services/dataService';
import { showResult } from 'infrastructure/hooks/utils';

import type { ApcmStatuses } from 'infrastructure/enums';

interface DataProps {
  patientGuid: string;
  apcmStatus: ApcmStatuses;
}

const getUrl = (patientGuid: string) =>
  `admins/admin-panel/patients/${patientGuid}/apcm-enrollment`;

export const updatePatientApcmStatusFn = async ({
  patientGuid,
  apcmStatus,
}: DataProps) => {
  const url = getUrl(patientGuid);

  const { error } = await dataService.updateOnly(url, { apcmStatus });

  if (error) {
    showResult(error);
    throw new Error(error);
  }

  return {
    patientGuid,
    apcmStatus,
  };
};
